import { faEllipsisStrokeVertical } from '@fortawesome/pro-light-svg-icons/faEllipsisStrokeVertical'
import { faPenLine } from '@fortawesome/pro-light-svg-icons/faPenLine'
import { faTrash } from '@fortawesome/pro-light-svg-icons/faTrash'

import Button from '@space-core/components/button'
import Icon from '@space-core/components/icon'

import ActionsMenu from '@space-shell/common/components/actionsMenu'
import { useTranslation } from 'react-i18next'

export type ExternalLinkDropdownProps = {
  handleEditLink: () => void
  handleRemoveLink: () => void
}

const ExternalLinkDropdown = ({ handleEditLink, handleRemoveLink }: ExternalLinkDropdownProps) => {
  const { t } = useTranslation()

  return (
    <ActionsMenu
      trigger={
        <Button
          variation='tertiary'
          data-test='external-link-dropdown'
          className='_d-flex _align-items-center _border-0 _p-2'>
          <span className='_sr-only'>context menu icon</span>
          <Icon icon={faEllipsisStrokeVertical} className='_text-gray-900 _text-2' />
        </Button>
      }>
      <ActionsMenu.Item onClickItem={handleEditLink} icon={<Icon icon={faPenLine} />}>
        {t('external_links.edit')}
      </ActionsMenu.Item>
      <ActionsMenu.Item onClickItem={handleRemoveLink} icon={<Icon icon={faTrash} />}>
        {t('external_links.remove')}
      </ActionsMenu.Item>
    </ActionsMenu>
  )
}

export default ExternalLinkDropdown
